import { ADD_BRANCH, ADD_COUNSELOR, ADD_DOCTOR, ADMIN_DELETE, ADMIN_GET, ADMIN_SEARCH, ADMIN_UPDATE, ADMIN_USER, DELETE_BRANCH, DELETE_COUNSELOR, DELETE_DOCTOR, GET_BRANCH, GET_COUNSELOR, GET_DOCTOR, SEARCH_BRANCH, SEARCH_COUNSELOR, SEARCH_DOCTOR, UPDATE_BRANCH, UPDATE_COUNSELOR, UPDATE_DOCTOR, REQUEST_CHANGE_PASSWORD, VERIFY_OTP } from "../actions/Master.action";

const initialState = {
    addDocotr: '',
    getDoctor: '',
    deleteDoctor: '',
    updateDoctor: '',
    addBranch: '',
    getBranch: '',
    updateBranch: '',
    deleteBranch: '',
    addCounselor: '',
    getCounselor: '',
    updateCounselor: '',
    deleteCounselor: '',
    adminUser: '',
    adminGet: '',
    adminUpdate: '',
    adminDelete: '',
    requestChangePassword: '',
    verifyOtp: '',
}

const masterReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADD_DOCTOR:
            return { ...state, addDocotr: action.payload };
        case GET_DOCTOR:
            return { ...state, getDoctor: action.payload };
        case DELETE_DOCTOR:
            return { ...state, deleteDoctor: action.payload };
        case SEARCH_DOCTOR:
            return { ...state, getDoctor: action.payload };
        case UPDATE_DOCTOR:
            return { ...state, updateDoctor: action.payload };
        case ADD_BRANCH:
            return { ...state, addBranch: action.payload };
        case GET_BRANCH:
            return { ...state, getBranch: action.payload };
        case SEARCH_BRANCH:
            return { ...state, searchBranch: action.payload };
        case UPDATE_BRANCH:
            return { ...state, updateBranch: action.payload };
        case DELETE_BRANCH:
            return { ...state, deleteBranch: action.payload };
        case ADD_COUNSELOR:
            return { ...state, addCounselor: action.payload };
        case GET_COUNSELOR:
            return { ...state, getCounselor: action.payload };
        case SEARCH_COUNSELOR:
            return { ...state, getCounselor: action.payload };
        case UPDATE_COUNSELOR:
            return { ...state, updateCounselor: action.payload };
        case DELETE_COUNSELOR:
            return { ...state, deleteCounselor: action.payload };
        case ADMIN_USER:
            return { ...state, adminUser: action.payload };
        case ADMIN_GET:
            return { ...state, adminGet: action.payload };
        case ADMIN_SEARCH:
            return { ...state, adminGet: action.payload };
        case ADMIN_UPDATE:
            return { ...state, adminUpdate: action.payload };
        case ADMIN_DELETE:
            return { ...state, adminDelete: action.payload };
        case REQUEST_CHANGE_PASSWORD:
            return { ...state, requestChangePassword: action.payload };
        case VERIFY_OTP:
            return { ...state, verifyOtp: action.payload };
        default:
            return state;
    }
}

export default masterReducer;